import _ from 'lodash'
import BaseViewModel from '../../../infraestructure/BaseViewModel'
import HighSchool from '../models/HighSchool'

export default class HighSchoolViewModel extends BaseViewModel {
  constructor(view) {
    super(view)
  }
  // INICIALIZADORES

  //#region CRUD

  onCreate() {
    let item = new HighSchool({
      state: "create",
      status: 1
    });
    return item;
  }

  onDelete(data) {
    let item = new HighSchool(data);
    item.state = "delete";
    return item;
  }

  onEdit(data) {
    let item = new HighSchool(data);
    item.state = "update";
    return item;
  }

  onSearchCollection() {
    return this.api.highSchools.find(this.getSearchQuery())
  }

  mapCollection(collection) {
    return _.map(collection, (data) => new HighSchool(data));
  }

  onSearchItem(id) {
    return this.api.highSchools.findOne(id)
  }

  onSave(data) {
    if (data.state === 'create')
      return this.api.highSchools.create(data.toSend())
    else
      return this.api.highSchools.update(data.id, data.toSend());
  }

  onDestroy(context, id) {
    context.api.highSchools.delete(id)
      .then(response => context.view.onSuccess(response.data))
      .catch(context.view.onError)
  }

  onCancel(context) {
    context.view.item = null;
  }

  import(file) {
    this.api.highSchools.import(file)
      .then(response => this.view.onImportResponse(response.data))
      .catch(this.view.onError)
  }

  exportToExcel() {
    this.api.highSchools.exportToExcel()
      .then(response => this.view.onExportResponse(response.data))
      .catch(this.view.onError)
  }

  // #endregion

  // #region BINDING DATA

  bindFormView(formData) {
    if (formData.state === 'update') {
    }
    setTimeout(() => {
      this.showModalLoading(this.view.conf, false);
    }, 400);
  }

  // #endregion

  // #region QUERIES

  /**
   * Metodo para buscar categorias de cursos
   * @param {String} data Query string para parametros de búsqueda
   */
  findCourseCategories(data) {
    this.api.highSchools.find(data)
      .then((response) => this.view.onSearchCourseCategoriesResponse(response.data.data))
      .catch(this.view.onError)
  }
  

  // #endregion

  //#region MAPPING DATA

  
  // #endregion

  // #region VALIDATIONS

  // #endregion
}
